export default __webpack_public_path__ + "static/media/leads.f4f6b934.svg";